module.exports = __webpack_public_path__ + "static/about-goldpartner-6d8a192cec78efbdc5004c226f8eca6c.png";